var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33325 4C1.33325 3.63181 1.63173 3.33333 1.99992 3.33333H13.9999C14.3681 3.33333 14.6666 3.63181 14.6666 4C14.6666 4.36819 14.3681 4.66667 13.9999 4.66667H1.99992C1.63173 4.66667 1.33325 4.36819 1.33325 4Z",
    fill: "#FF8BA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66659 2C6.48977 2 6.32021 2.07024 6.19518 2.19526C6.07016 2.32029 5.99992 2.48986 5.99992 2.66667V4C5.99992 4.36819 5.70144 4.66667 5.33325 4.66667C4.96506 4.66667 4.66659 4.36819 4.66659 4V2.66667C4.66659 2.13623 4.8773 1.62752 5.25237 1.25245C5.62744 0.87738 6.13615 0.666666 6.66659 0.666666H9.33325C9.86368 0.666666 10.3724 0.87738 10.7475 1.25245C11.1225 1.62752 11.3333 2.13623 11.3333 2.66667V4C11.3333 4.36819 11.0348 4.66667 10.6666 4.66667C10.2984 4.66667 9.99992 4.36819 9.99992 4V2.66667C9.99992 2.48986 9.92968 2.32029 9.80466 2.19526C9.67963 2.07024 9.51006 2 9.33325 2H6.66659ZM3.33325 3.33333C3.70144 3.33333 3.99992 3.63181 3.99992 4V13.3333C3.99992 13.5101 4.07016 13.6797 4.19518 13.8047C4.32021 13.9298 4.48977 14 4.66659 14H11.3333C11.5101 14 11.6796 13.9298 11.8047 13.8047C11.9297 13.6797 11.9999 13.5101 11.9999 13.3333V4C11.9999 3.63181 12.2984 3.33333 12.6666 3.33333C13.0348 3.33333 13.3333 3.63181 13.3333 4V13.3333C13.3333 13.8638 13.1225 14.3725 12.7475 14.7475C12.3724 15.1226 11.8637 15.3333 11.3333 15.3333H4.66659C4.13615 15.3333 3.62744 15.1226 3.25237 14.7475C2.8773 14.3725 2.66659 13.8638 2.66659 13.3333V4C2.66659 3.63181 2.96506 3.33333 3.33325 3.33333Z",
    fill: "#FF8BA7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66659 6.66667C7.03478 6.66667 7.33325 6.96514 7.33325 7.33333V11.3333C7.33325 11.7015 7.03478 12 6.66659 12C6.2984 12 5.99992 11.7015 5.99992 11.3333V7.33333C5.99992 6.96514 6.2984 6.66667 6.66659 6.66667Z",
    fill: "#FF8BA7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33325 6.66667C9.70144 6.66667 9.99992 6.96514 9.99992 7.33333V11.3333C9.99992 11.7015 9.70144 12 9.33325 12C8.96506 12 8.66659 11.7015 8.66659 11.3333V7.33333C8.66659 6.96514 8.96506 6.66667 9.33325 6.66667Z",
    fill: "#FF8BA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash2);
export default __webpack_public_path__ + "static/media/trash-2.f8b9dc641310d39e012cc5c985a0da67.svg";
export { ForwardRef as ReactComponent };